export const CONVERSATION_CACHE_KEY = "CONVERSATION";
export const CONVERSATION_EVENT_CACHE_KEY = ["CONVERSATION", "EVENTS"];
export const CONVERSATION_COUNT_CACHE_KEY = [CONVERSATION_CACHE_KEY, "COUNT"];
export const CONVERSATION_LIST_CACHE_KEY = [CONVERSATION_CACHE_KEY, "LIST"];
export const UNREAD_MENTION_COUNT_SCOPE = "unread-mentions";
export const UNREAD_MENTION_REVISION_SCOPE = "unread-mention-revision";

/**
 * Sentinels at index 2 of a conversation-count key marking the buckets that are
 * reconcilable from a contact diff: index 3 of those keys holds the `CountFilter`
 * they were fetched with, which `reconcileStateCounts` re-evaluates per contact.
 * Every other count scope keys something opaque there and keeps its own patcher.
 */
export const STATE_COUNT_SCOPE = "state";
export const ATTENTION_COUNT_SCOPE = "attention";

/**
 * Sentinel at index 2 of the owner-split group counts (Unattended, Follow-ups),
 * with the view itself at index 3 and the viewer at index 4. Not reconcilable:
 * the key holds a view rather than a `CountFilter`, so these refresh through
 * `invalidateAllCounts()` like the other opaque scopes.
 */
export const VIEW_BUCKET_COUNT_SCOPE = "view-buckets";

/**
 * Not a reconcilable scope: index 3 of a match-count key holds a raw filter
 * group (what a custom view is being edited into), not a `CountFilter`.
 */
export const MATCH_COUNT_SCOPE = "match";

// Sentinel at index 2 of the follow-up-due count key, marking that bucket as
// scoped to the current user (`assignedTo=me`) rather than the workspace-wide
// state counts. Lets the optimistic patches tell the personal nudge apart from
// the global counts.
export const MINE_DUE_FOLLOW_UP_SCOPE = "mine-due-follow-up";

export const UNREPLIED_HANDOFF_COUNT_KEY = ["AI_HANDOFF", "UNREPLIED_COUNT"];
